<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" width="300" app dark
    :disable-route-watcher="true" color="#202020">
    <v-list dense rounded class="mt-3">
      <v-list-item-group v-model="singleModel" color="primary">
        <template v-for="(item, i) in children(items)">
          <v-list-group v-if="item.children && item.disabled === false" v-model="item.model" no-action :key="i"
            :prepend-icon="item.prepend" :append-icon="item.model ? item.icon : item['icon-alt']"
            @click="controlGroup(i)">
            <template v-slot:activator>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </template>

            <v-list-item v-for="(child, i) in children(item.children)" :key="i" @click="go(child.href)"
              @input="groupSwap" :class="{ 'active-nav-custom': child.href === $route.name }">
              <v-list-item-title>
                {{ child.text }}
              </v-list-item-title>

              <v-list-item-icon v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else-if="!(item.sub && isUserSub) && item.disabled === false" :key="item.text"
            @click="item.route ? go(item.route) : $trigger(item.action)">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-item-group>
      <!--        <template v-for="item in children(items)">-->
      <!--          <v-list-group-->
      <!--              no-action-->
      <!--              v-if="item.children"-->
      <!--              :key="item.text"-->
      <!--              v-model="item.model"-->
      <!--              :prepend-icon="item.prepend"-->
      <!--              :append-icon="item.model ? item.icon : item['icon-alt']">-->

      <!--                <template v-slot:activator >-->
      <!--                  <v-list-item-title >-->
      <!--                    {{ item.text }}-->
      <!--                  </v-list-item-title>-->
      <!--                </template>-->

      <!--                <v-list-item-->
      <!--                  v-for="(child, i) in children(item.children)"-->
      <!--                  :key="i"-->
      <!--                  @click="go(child.href)"-->
      <!--                  :class="{ 'active-nav-custom' : child.href === $route.name }">-->
      <!--                    <v-list-item-title>-->
      <!--                      {{ child.text }}-->
      <!--                    </v-list-item-title>-->

      <!--                    <v-list-item-icon v-if="child.icon">-->
      <!--                      <v-icon>{{ child.icon }}</v-icon>-->
      <!--                    </v-list-item-icon>-->
      <!--                </v-list-item>-->
      <!--            </v-list-group>-->
      <!--          <v-list-item-group-->
      <!--            v-else-if="!(item.sub && isUserSub)"-->
      <!--            v-model="singleModel"-->
      <!--            color="primary"-->
      <!--            :key="item.text">-->
      <!--            <v-list-item-->
      <!--              @click="item.route ? go(item.route) : $trigger(item.action)">-->
      <!--              <v-list-item-action>-->
      <!--                <v-icon>{{ item.icon }}</v-icon>-->
      <!--              </v-list-item-action>-->
      <!--              <v-list-item-content>-->
      <!--                <v-list-item-title>-->
      <!--                  {{ item.text }}-->
      <!--                </v-list-item-title>-->
      <!--              </v-list-item-content>-->
      <!--            </v-list-item>-->

      <!--          </v-list-item-group>-->
      <!--        </template>-->
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import store from '../../store';

export default {
  name: 'NavigationDrawer',
  data: () => ({
    drawer: null,
    latestGroupModel: -1,
    singleModel: -1,
    items: [
      {
        icon: "dashboard",
        text: "Anasayfa",
        route: "dashboard",
        disabled: false,
      },
      {
        prepend: "send",
        icon: "keyboard_arrow_down",
        "icon-alt": "keyboard_arrow_down",
        text: "SMS İşlemleri",
        model: false,
        disabled: false,
        children: [
          { icon: "mdi-send", text: "Gruplara SMS", href: "sms.group.index" },
          {
            icon: "mdi-file-excel-outline",
            text: "Excel ile SMS",
            href: "sms.bulk.excel",
          },
          {
            icon: "mdi-file-excel",
            text: "Özel Excel ile SMS",
            href: "sms.special.excel",
          },
          {
            icon: "mdi-phone-message",
            text: "Toplu Numaralara SMS",
            href: "sms.group.bulk_number",
          },
          {
            icon: "mdi-account-multiple-check",
            text: "Seçili Kayıtlara SMS",
            href: "sms.group.selective",
          },
          {
            icon: "mdi-email",
            text: "Tek Numaraya SMS",
            href: "sms.send.number",
          },
        ],
      },
      {
        prepend: 'mdi-whatsapp',
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        text: 'Whatsapp İşlemleri',
        model: false,
        disabled: false,
        children: [
          { icon: 'mdi-whatsapp', text: 'Gruplara Mesaj', href: 'whatsapp.group.index' },
          {
            icon: 'mdi-file-excel-outline',
            text: 'Excel ile Mesaj',
            href: 'whatsapp.bulk.excel',
          },
          {
            icon: 'mdi-file-excel',
            text: 'Özel Excel ile Mesaj',
            href: 'whatsapp.special.excel',
          },
          {
            icon: 'mdi-email-multiple',
            text: 'Toplu Numaralara Mesaj',
            href: 'whatsapp.group.bulk_number',
          },
          {
            icon: 'mdi-account-multiple-check',
            text: 'Seçili Kayıtlara Mesaj',
            href: 'whatsapp.group.selective',
          },
          {
            icon: 'mdi-email',
            text: 'Tek Numaraya Mesaj',
            href: 'whatsapp.send.number',
          },
          {
            icon: 'report',
            text: 'Raporlar',
            href: 'whatsapp.reports.index',
          },
          {
            icon: 'search',
            text: 'Raporlarda Ara',
            href: 'whatsapp.report.search',
          },
          {
            icon: 'mdi-file-document',
            text: 'API Dokümantasyonu',
            href: 'whatsapp.documentation.index',
          },
          {
            icon: 'shopping_cart',
            text: 'Paket Fiyat Listesi',
            href: 'whatsapp.prices.index',
          },
          {
            icon: 'settings',
            text: 'Whatsapp Kurulum',
            href: 'whatsapp.settings',
          },
        ],
      },
      {
        prepend: "mdi-checkbox-marked-circle",
        icon: "keyboard_arrow_down",
        "icon-alt": "keyboard_arrow_down",
        text: "İYS İzin İşlemleri",
        model: false,
        disabled: store.state.iys_status === 0,
        children: [
          { icon: "mdi-file-document", text: "İYS Raporu", href: "iys.report" },
          {
            icon: "mdi-check-bold",
            text: "İzin Ekle",
            href: "iys.permission.add",
          },
          {
            icon: "mdi-file-excel",
            text: "Excelden Ekle",
            href: "iys.permission.excel_add",
          },
          {
            icon: "mdi-magnify",
            text: "İzin Sorgula",
            href: "iys.permission_query",
          },
          {
            icon: "mdi-block-helper",
            text: "Tüm Engellenenler",
            href: "iys.blocked_list",
          },
          /* { icon: "mdi-office-building-outline", text: "Markalarım", href: "" }, */
        ],
      },
      {
        prepend: "contacts",
        icon: "keyboard_arrow_down",
        "icon-alt": "keyboard_arrow_down",
        text: "Rehber İşlemleri",
        model: false,
        disabled: false,
        children: [
          {
            text: "Numara Ekle",
            href: "contact.create",
          },
          {
            text: "Tüm Rehberi Listele",
            href: "contact.list",
          },
          {
            text: "Grupları Listele",
            href: "group.contacts.index",
          },
        ],
      },
      {
        prepend: "report",
        icon: "keyboard_arrow_down",
        "icon-alt": "keyboard_arrow_down",
        text: "Rapor İşlemleri",
        model: false,
        disabled: false,
        children: [
          { icon: "", text: "Tüm Raporlar", href: "report.index" },
          { icon: "", text: "Raporlarda Arama", href: "report.search" },
          { icon: "", text: "Gelen Mesaj Raporları", href: "report.incoming" },
        ],
      },
      {
        icon: "shopping_cart",
        text: "Paket Fiyat Listesi",
        route: "prices.index",
        sub: true,
        disabled: false,
      },
      {
        prepend: "payment",
        icon: "keyboard_arrow_down",
        "icon-alt": "keyboard_arrow_down",
        text: "Ödeme İşlemleri",
        model: false,
        disabled: !store.state.user.sender_active,
        sub: true, // sub key'i, alt kullanıcıya gösterilmeyeceğini işaret ediyor.
        children: [
          {
            icon: "create",
            text: "Ödeme Geçmişi Listesi",
            href: "payments.index",
            sub: true,
          },
          {
            icon: "notifications_none",
            text: "Ödeme Bildirimi",
            href: "payments.notify",
          },
          {
            icon: "account_balance",
            text: "Banka Hesapları",
            href: "bank.accounts.index",
          },
        ],
      },
      {
        icon: "insert_invitation",
        text: "Gönderici Adları",
        route: "sender.index",
        sub: true,
        disabled: false,
      },
      {
        icon: "people_alt",
        text: "Alt Kullanıcı İşlemleri",
        sub: true,
        route: "user.sub.index",
        disabled: false,
      },

      {
        prepend: "gesture",
        icon: "keyboard_arrow_down",
        "icon-alt": "keyboard_arrow_down",
        text: "Şablon İşlemleri",
        model: false,
        disabled: false,
        children: [
          {
            icon: "create",
            text: "Şablon Oluştur",
            href: "template.sms.create",
          },
          { icon: "list", text: "Tüm Şablonlar", href: "template.sms.index" },
          { icon: "cake", text: "Doğum Günü", href: "birthday.index" },
        ],
      },
      {
        icon: "voice_over_off",
        text: "Kara Liste",
        route: "blacklist.index",
        disabled: false,
      },
      {
        icon: "code",
        text: "İptal Linki/Kısa Kod",
        route: "cancel.index",
        disabled: false,
      },
      // {
      //   prepend: 'gesture',
      //   icon: 'keyboard_arrow_up',
      //   'icon-alt': 'keyboard_arrow_down',
      //   text: 'IYS Yönetimi',
      //   model: false,
      //   children: [
      //     { icon: '', text: 'İYS Raporu', href: 'template.sms.create' },
      //     { icon: '', text: 'İzin Ekle', href: 'template.sms.index' },
      //     { icon: '', text: 'Excel İle İzin Ekle', href: 'birthday.index' },
      //     { icon: '', text: 'İzin Sorgula', href: 'birthday.index' },
      //     { icon: '', text: 'Markalarım', href: 'birthday.index' },
      //
      //   ],
      // },
      {
        icon: "settings",
        text: "Hesap",
        route: "settings.index",
        disabled: false,
      },
      {
        icon: "visibility",
        text: "Diğer Projelerimiz",
        route: "projects.index",
        disabled: false,
      },
      {
        icon: "logout",
        text: "Çıkış Yap",
        action: "menu:logout",
        disabled: false,
      },
    ],
  }),
  computed: {
    ...mapFields(['user']),
    isUserSub() {
      // eslint-disable-next-line no-prototype-builtins
      return this.user.hasOwnProperty('parent_user_id') && this.user.parent_user_id !== null;
    },
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    controlGroup(i) {
      this.latestGroupModel = i;
    },
    groupSwap() {
      this.singleModel = this.latestGroupModel;
      // eslint-disable-next-line no-prototype-builtins
      if (this.items[this.latestGroupModel].hasOwnProperty('model')) {
        this.items[this.latestGroupModel].model = true;
      }
    },
    setDrawer() {
      this.drawer = !this.drawer;
    },
    go(where) {
      this.$router.push({ name: where }).catch((err) => {
        console.log(err);
      });
    },
    children(items) {
      let children = items;
      children = children.filter(el => !(this.isUserSub && el.sub));

      return children;
    },
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({ name: 'login' });
      });
    },
  },
  events: {
    'set:drawer': 'setDrawer',
    'menu:logout': 'logout',
  },
};
</script>

<style scoped>
.non-activated-nav {
  top: 118px !important;
}
</style>
